import React from "react";
import Select from 'react-select';

import SelectInput, { styles } from "../../../../Components/Inputs/SelectInput";
import CheckboxInput from "../../../../Components/Inputs/CheckboxInput";
import EntityConfigSection from "../../Components/EntityConfigSection";
import DurationInput from "../../../../Components/Inputs/DurationInput";
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import StackedFormRow from "../../../../Components/StackedForm/StackedFormRow";
import QuantitySelectInput from "../../../../Components/Inputs/QuantitySelectInput";

const EntityTimeslotConfig = (props) => {
    const isVariableOptions = [
        {
            label: 'Fixed',
            value: 0,
        },
        {
            label: 'Variable',
            value: 1,
        },
    ];

    const getDurationLabel = () => {
        return props.config.is_variable ? 'Max Booking Duration' : 'Timeslot Duration';
    }

    const handleIsVariableChange = (name, value) => {
        if (value) {
            // Clear values not valid for is_variable === 1
            props.onChange('max_simultaneous', 1);
        } else {
            // Clear values not valid for is_variable === 0
            props.onChange('buffer_check', false);
            props.onChange('buffer', null);
        }

        props.onChange(name, value);
    }

    return (
        <EntityConfigSection title="Timeslot" isExpanded={props.isExpanded}>
            <StackedFormRow
                label="Type"
                errorMessage=""
                required
                labelClassName="margin-bottom-0"
            >
                <SelectInput
                    name="is_variable"
                    options={isVariableOptions}
                    value={props.config.is_variable}
                    onChange={(e) => handleIsVariableChange(e.target.name, e.target.value) }
                    className="react-select-container display-inline-block"
                    styles={styles}
                />
            </StackedFormRow>

            <StackedFormRow
                label={getDurationLabel()}
                errorMessage={props.errors.duration}
                required
                labelClassName="margin-bottom-0"
            >
                <DurationInput
                    name="duration"
                    value={props.config.duration}
                    onChange={(name, value) => props.onChange(name, value, null, false)}
                    maxDuration={60 * 24}
                    minDuration={15}
                    minutesStep={15}
                />
            </StackedFormRow>

            { (props.config.is_variable === 1) && (<>
                <FormRow
                    label="Buffer"
                    errorMessage=""
                    tooltip={"A stipulated time reserved after a booking ends for purposes such as cleaning/rearranging, etc.\n\nOnly available for variable type bookings"}
                    className="align-middle"
                    leftCellClassName="cell small-12 medium-9"
                    rightCellClassName="cell small-12 medium-3 text-right"
                >
                    <CheckboxInput
                        name="buffer_check"
                        checked={props.config.buffer_check}
                        onChange={e => props.onChange(e.target.name, e.target.checked)}
                    />
                </FormRow>

                { (props.config.buffer_check) &&
                    <StackedFormRow
                        label="Buffer Duration"
                        errorMessage={props.errors.buffer}
                        required
                        labelClassName="margin-bottom-0"
                    >
                        <DurationInput
                            name="buffer"
                            value={props.config.buffer}
                            onChange={(name, value) => props.onChange(name, value, null, false)}
                            maxDuration={120}
                            minDuration={0}
                            minutesStep={15}
                        />
                    </StackedFormRow>
                }
            </>)}

            { (props.config.is_variable === 0) && (
                <StackedFormRow
                    label="Simultaneous Bookings"
                    errorMessage={props.errors.max_simultaneous}
                    required
                    labelClassName="margin-bottom-0"
                >
                    <QuantitySelectInput
                        name="max_simultaneous"
                        value={props.config.max_simultaneous}
                        onChange={props.onChange}
                        singleLabel="No"
                    />
                </StackedFormRow>
            )}

        </EntityConfigSection>
    )
}

EntityTimeslotConfig.defaultProps = {
    isExpanded: false,
}

export default EntityTimeslotConfig;
